import toast from "react-hot-toast"

export const sendErrorNotification = (message) => {
  toast.dismiss();
  toast.error(message);
};

export const sendInfoNotification = (message) => {
  toast.dismiss();
  toast(message);
};

export const sendWarningNotification = (message) => {
  toast.dismiss();
  toast(message);
};

export const sendSuccessNotification = (message) => {
  toast.dismiss();
  toast.success(message);
};